import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

///////////////////////////////////////////////////////////////////
// Reviews load

export const STROLLER_ALL_REVIEWS_GALLERY_FETCH_TRIGGER =
    "STROLLER_ALL_REVIEWS_GALLERY_FETCH_TRIGGER";
export interface StrollerAllReviewsGalleryFetchTriggerAction {
    readonly type: typeof STROLLER_ALL_REVIEWS_GALLERY_FETCH_TRIGGER;
    readonly strollerSlug: string;
}
export const STROLLER_ALL_REVIEWS_GALLERY_FETCH_REQUEST =
    "STROLLER_ALL_REVIEWS_GALLERY_FETCH_REQUEST";
export interface StrollerAllReviewsGalleryFetchRequestAction extends APIRequestAction {
    readonly type: typeof STROLLER_ALL_REVIEWS_GALLERY_FETCH_REQUEST;
    readonly strollerSlug: string;
}
export interface StrollerAllReviewsGalleryFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        stroller: number;
        strollerReviews: number[];
    };
}
export const STROLLER_ALL_REVIEWS_GALLERY_FETCH_SUCCESS =
    "STROLLER_ALL_REVIEWS_GALLERY_FETCH_SUCCESS";
export interface StrollerAllReviewsGalleryFetchSuccessAction extends APISuccessAction<StrollerAllReviewsGalleryFetchNormalizedResponse> {
    readonly type: typeof STROLLER_ALL_REVIEWS_GALLERY_FETCH_SUCCESS;
    readonly strollerSlug: string;
}
export const STROLLER_ALL_REVIEWS_GALLERY_FETCH_FAILURE =
    "STROLLER_ALL_REVIEWS_GALLERY_FETCH_FAILURE";
export interface StrollerAllReviewsGalleryFetchFailureAction extends APIFailureAction {
    readonly type: typeof STROLLER_ALL_REVIEWS_GALLERY_FETCH_FAILURE;
    readonly strollerSlug: string;
}

export const strollerAllReviewsGalleryFetchTrigger = (
    strollerSlug: string,
): StrollerAllReviewsGalleryFetchTriggerAction => ({
    type: STROLLER_ALL_REVIEWS_GALLERY_FETCH_TRIGGER,
    strollerSlug,
});
export const strollerAllReviewsGalleryFetchApi = {
    request: (strollerSlug: string): StrollerAllReviewsGalleryFetchRequestAction => ({
        type: STROLLER_ALL_REVIEWS_GALLERY_FETCH_REQUEST,
        strollerSlug,
    }),
    success: (
        strollerSlug: string,
        response: StrollerAllReviewsGalleryFetchNormalizedResponse,
    ): StrollerAllReviewsGalleryFetchSuccessAction => ({
        type: STROLLER_ALL_REVIEWS_GALLERY_FETCH_SUCCESS,
        strollerSlug,
        response,
    }),
    failure: (
        strollerSlug: string,
        error: string,
    ): StrollerAllReviewsGalleryFetchFailureAction => ({
        type: STROLLER_ALL_REVIEWS_GALLERY_FETCH_FAILURE,
        strollerSlug,
        error,
    }),
};
